import config from "@/common/config";

import ApiService from "./api.service";

export default {
  VERSION: config.api.versions.v2,

  /**
   * @param {string} returnUrl
   * @param {string} redirectUrl
   */
  request(returnUrl, redirectUrl) {
    return ApiService.post("auth/unilogin/request", { returnUrl, redirectUrl }, this.VERSION);
  },

  /**
   * @param {import("@/common/types/auth").UniloginCredentials} credentials
   *
   * @returns {Promise<import("axios").AxiosResponse<import("./types").ApiResponse<import("./types").UniloginResponse>>>}
   */
  response(credentials) {
    return ApiService.post("auth/unilogin/response", credentials, this.VERSION);
  }
};
